// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { type AuthUser } from '@/types';

export default defineNuxtRouteMiddleware((middleware) => {
  const { isAuthenticated } = useSanctumAuth();
  const user: Ref<AuthUser | null> = useSanctumUser();

  if (isAuthenticated.value && user.value) {
    return navigateTo('/vdp/start-program');
  }
});
